

// Utility to convert local URI to Base64 for React Native
export const convertPathToBase64 = async (uri) => {
    if (!uri) return "";


    try {
        // Check if the URI is already in Base64 format
        if (uri.startsWith("data:image/") || uri.startsWith("data:application/") && uri.includes("base64,")) {
            return uri;
        }

        return "";
    } catch (error) {
        console.error("Error converting local path to base64:", error);
        return "";
    }
};

// Utility to convert base64 to binary (Native & Web)
export const convertBase64ToBinary = (base64) => {

    const base64WithoutPrefix = base64.startsWith("data:") ? base64.split(",")[1] : base64;

    const binaryString = atob(base64WithoutPrefix);
    const len = binaryString.length;
    const binaryArray = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        binaryArray[i] = binaryString.charCodeAt(i);
    }
    return binaryArray;
};


export const convertImageToBinaryBlob = async (uri) => {
    if (!uri) return null;

    try {
        // Convert the path to Base64
        const base64Data = await convertPathToBase64(uri);

        // Convert the Base64 to binary
        const binaryData = convertBase64ToBinary(base64Data);

        return new Blob([binaryData], { type: "image/jpeg" });
    } catch (error) {
        console.error("Error converting image to binary:", error);
        return null;
    }
};